'use client';

import { forwardRef, useContext } from 'react';

import { css, cx } from '@/styled-system/css';

import { MenuItemContext } from './context/menu-item.context';
import { menuItemMetaRecipe } from './styles/menu-item-meta.styles';
import type { MenuItemMetaPropsInterface } from './types/menu-item-meta.types';

/**
 * @since 10.0.0
 */
export const MenuItemMeta = forwardRef<HTMLSpanElement, MenuItemMetaPropsInterface>(
  (props: MenuItemMetaPropsInterface, forwardedRef) => {
    const { disabled } = useContext(MenuItemContext);
    const { className, css: cssProp, ...rest } = props;
    const styles = css(menuItemMetaRecipe.raw({ disabled }), cssProp);
    return (
      <span
        ref={forwardedRef}
        data-c11n-component="Menu.ItemMeta"
        data-c11n-version={__C11N_VERSION__}
        className={cx('c11n', styles, className)}
        {...rest}
      />
    );
  },
);

MenuItemMeta.displayName = 'Menu.ItemMeta';
